// extracted by mini-css-extract-plugin
export default {"addCardModal":"AddCard_addCardModal__PKkvg","closeModal":"AddCard_closeModal__iPzgF","header":"AddCard_header__3w58h"};